import React, { Fragment } from 'react'
import Picture from '../../components/Picture'
import DemoFormB2B from '../../components/site/Forms/DemoFormB2B'

import './CardsEstrategias.scss'

export default function CardsEstrategiasB2B(props) {
    return (
        <Fragment>
            {props.CTA ? (<section className="new-sales-cta">
                <div className="container">
                    <DemoFormB2B  />
                </div>
            </section>) : ''}
            <section className="cards-estrategias">
                <div className="container">
                    <h2 className='title'>
                        {props.title}
                    </h2>
                </div>
                <div className="wrapper">
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/b2b/positivacao.png"
                            alt='Positivação de clientes'
                        />
                        <h4 className="card-title">Positivação de clientes</h4>
                        <h5 className='card-description'>Identifique as visitas recebidas, quantas adicionaram produtos ao carrinho e a conversão em pedidos.</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/b2b/evolucao.png"
                            alt='Evolução de Vendas'
                        />
                        <h4 className="card-title">Evolução de Vendas</h4>
                        <h5 className='card-description'>Acompanhe o resultado de vendas em tempo real e veja o quanto falta de vendas diárias para a meta.</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/b2b/positivacao-clientes.png"
                            alt='Positivação de clientes'
                        />
                        <h4 className="card-title">Positivação de clientes</h4>
                        <h5 className='card-description'>Veja a quantidade de clientes que realizou um pedido no mês em tempo real.</h5>
                    </div>
                    <div className="card">
                        <Picture
                            className='new-sales-features-img'
                            src="/images/site/landing-pages/b2b/acesso-ecommerce.png"
                            alt='Acessos e Atividades do E-commerce'
                        />
                        <h4 className="card-title">Acessos e Atividades do E-commerce</h4>
                        <h5 className='card-description'>Saiba o que cada cliente realizou enquanto navegava pelo seu catálogo e aumente suas vendas.</h5>
                    </div>

                </div>

            </section>
        </Fragment>
    )
}



// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/CardsEstrategias/CardsEstrategiasB2B.jsx